var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MediaWatcher',{ref:"mediaWatcherVideo",attrs:{"items":_vm.videos,"type":"video","canDelete":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }